import Header from 'components/headers/bulletins'
import { useState } from 'react'
import SubscriptionIcon from 'assets/images/buySubscription/subscription.svg'
import SelectedSubscriptionIcon from 'assets/images/buySubscription/subscription-selected.svg'
import classNames from 'classnames'
import useGetInitBanks from './hooks/useGetInitBanks'
import DotsLoading from 'components/loadings/dotsLoading'
import useSetPayment from './hooks/useSetPayment'
import { toast } from 'react-toastify'
import { useParams } from 'react-router-dom'
import { toggleSupportModal } from 'store/redux/sidebar'
import { useDispatch, useSelector } from 'react-redux'
import SupportModal from 'components/modals/supportModal'
import { RootState } from 'store/redux'
import { ISelectedBank } from 'utilities/hooks/useIsDefaultGateway'

export default function Subscription() {
    const [isSelected, setIsSelected] = useState<ISelectedBank>({
        saderat: false,
        parsian: true,
    })
    const [selectedPlan, setSelectedPlan] = useState<string>('monthly')
    const { data, isLoading } = useGetInitBanks()
    const { mutate } = useSetPayment()
    const { moneyPool } = useParams()
    const dispatch = useDispatch()
    const { isOpenSupportModal } = useSelector(
        (state: RootState) => state.sideBarControler
    )
    return (
        <>
            <div className="flex flex-col bg-[#F2F2F2] h-screen">
                <div className=" grow-0">
                    <Header title={`ارتقاء صندوق`} />
                </div>
                <div className=" grow bg-white px-2 py-2 w-full">
                    <p className="my-3 text-center text-xl">
                        نسخه های انتخابی شما برای ارتقای صندوق پس انداز
                    </p>
                    {/* <div
                        className={classNames(
                            'flex items-start mx-2 rounded-lg p-3 mb-2 cursor-pointer',
                            selectedPlan === 'yearly'
                                ? ' bg-plan-bg border-1 border-green-1'
                                : 'bg-white border-1 border-[#C9CFD6]'
                        )}
                        onClick={() => setSelectedPlan('yearly')}
                    >
                        <img
                            src={
                                selectedPlan === 'yearly'
                                    ? SelectedSubscriptionIcon
                                    : SubscriptionIcon
                            }
                            alt="subs"
                        />
                        <div className=" w-full mr-2">
                            <div className=" flex justify-between">
                                <p>اشتراک یک ساله</p>
                                <p className=" line-through text-[#A5ADB8]">
                                    ۱,۸۰۰,۰۰۰ تومان
                                </p>
                            </div>
                            <div className=" flex justify-between mt-2">
                                <p className=" text-sm">به ازای هر ۵۰ نفر</p>
                                <p className=" text-green-1">۱,۵۰۰,۰۰۰ تومان</p>
                            </div>
                        </div>
                    </div> */}
                    <div
                        className={classNames(
                            'flex items-start mx-2 rounded-lg p-3 mt-2 cursor-pointer',
                            selectedPlan === 'monthly'
                                ? ' bg-plan-bg border-1 border-green-1'
                                : ' bg-white border-1 border-[#C9CFD6]'
                        )}
                        onClick={() => setSelectedPlan('monthly')}
                    >
                        <img
                            src={
                                selectedPlan === 'monthly'
                                    ? SelectedSubscriptionIcon
                                    : SubscriptionIcon
                            }
                            alt="subs"
                        />
                        <div className=" w-full mr-2">
                            <div className=" flex justify-between">
                                <p className="font-bold">اشتراک یک ماهه</p>
                            </div>
                            <div className=" flex justify-between mt-2">
                                <p className=" text-sm">به ازای هر ۵۰ نفر</p>
                                <p className=" text-green-1">۱۵۰,۰۰۰ تومان</p>
                            </div>
                        </div>
                    </div>
                    <div
                        className={classNames(
                            'flex items-start mx-2 rounded-lg p-3 mt-2 cursor-pointer',
                            selectedPlan === 'treeMonthly'
                                ? ' bg-plan-bg border-1 border-green-1'
                                : ' bg-white border-1 border-[#C9CFD6]'
                        )}
                        onClick={() => setSelectedPlan('treeMonthly')}
                    >
                        <img
                            src={
                                selectedPlan === 'treeMonthly'
                                    ? SelectedSubscriptionIcon
                                    : SubscriptionIcon
                            }
                            alt="subs"
                        />
                        <div className=" w-full mr-2">
                            <div className=" flex justify-between">
                                <p className="font-bold">اشتراک سه ماهه</p>
                            </div>
                            <div className=" flex justify-between mt-2">
                                <p className=" text-sm">به ازای هر ۵۰ نفر</p>
                                <p className=" text-green-1">۴۵۰,۰۰۰ تومان</p>
                            </div>
                        </div>
                    </div>
                    <div className=" my-2 mx-2">
                        <p>روش پرداخت</p>
                        <div className=" mt-3 rounded-lg border-1 border-[#C9CFD6] p-3">
                            <p className="mb-2">صورتحساب</p>
                            <div className=" flex justify-between text-sm">
                                <p>ارزش بسته اشتراک</p>
                                <p>
                                    {selectedPlan === 'monthly'
                                        ? '۱۵۰,۰۰۰ تومان'
                                        : '۴۵۰,۰۰۰ تومان'}
                                </p>
                            </div>
                            <div className=" flex justify-between text-sm">
                                <p>مبلغ قابل پرداخت</p>
                                <p className=" text-green-1">
                                    {selectedPlan === 'monthly'
                                        ? '۱,۵۰۰,۰۰۰ تومان'
                                        : '۱۵۰,۰۰۰ تومان'}
                                </p>
                            </div>
                        </div>
                    </div>
                    {!isLoading && data ? (
                        <div className=" w-full items-center text-center mt-3 mb-3">
                            <div className="flex justify-center h-16 w-1/2 mr-[25%]">
                                <img
                                    src={
                                        data?.gateways &&
                                        data?.gateways[0]?.img_url
                                    }
                                    hidden={!data?.gateways[0]?.is_active}
                                    alt="bank"
                                    className={classNames(
                                        'mx-2 cursor-pointer',
                                        !isSelected.saderat
                                            ? ' border-1 border-gray-4 rounded-md'
                                            : 'border-2 border-green-1 rounded-md'
                                    )}
                                    onClick={() =>
                                        setIsSelected({
                                            saderat: false,
                                            parsian: true,
                                        })
                                    }
                                />
                                <img
                                    src={
                                        data?.gateways &&
                                        data?.gateways[1]?.img_url
                                    }
                                    hidden={!data?.gateways[1]?.is_active}
                                    alt="bank"
                                    className={classNames(
                                        'mx-2 cursor-pointer',
                                        !isSelected.parsian
                                            ? ' border-1 border-gray-4 rounded-md'
                                            : 'border-2 border-green-1 rounded-md'
                                    )}
                                    onClick={() =>
                                        setIsSelected({
                                            saderat: true,
                                            parsian: false,
                                        })
                                    }
                                />
                            </div>
                        </div>
                    ) : (
                        <DotsLoading />
                    )}
                </div>
                <div className="grow-0 mx-2 mt-2">
                    <div className=" my-1 text-center">
                        <p>نیاز به راهنمایی دارید؟</p>
                        <p
                            className=" text-[#808080] underline-offset-8"
                            onClick={() =>
                                dispatch(
                                    toggleSupportModal({
                                        isOpenSupportModal: true,
                                    })
                                )
                            }
                        >
                            با مشاور همیان تماس بگیرید
                        </p>
                    </div>
                    {/* <button
                        className=" w-full rounded-lg bg-green-1 text-white py-3 mt-4 mb-2"
                        onClick={() => {
                            if (data) {
                                if (isSelected.saderat || isSelected.parsian) {
                                    const payload: ISetSubscriptionPaymentPayload =
                                        {
                                            gateway: isSelected.saderat ? 5 : 9,
                                            monthCount:
                                                selectedPlan === 'monthly'
                                                    ? 1
                                                    : 3,
                                            ctxId: Number(moneyPool),
                                        }
                                    mutate(payload)
                                } else {
                                    toast.error(
                                        'نوع درگاه پرداخت را انتخاب کنید'
                                    )
                                }
                            }
                        }}
                    >
                        انتخاب
                    </button> */}
                </div>
            </div>
            <SupportModal
                show={isOpenSupportModal}
                onHide={() =>
                    dispatch(toggleSupportModal({ isOpenSupportModal: false }))
                }
            />
        </>
    )
}
